export class ProductDetailsModelImage {
  public url: string;
  public selected: boolean;
}
